import MoveBooking from "../../components/booking/MoveBooking.tsx";
import { useParams, useSearchParams } from "react-router";
import BackButton from "../../components/navigation/BackButton.tsx";
import Container from "../../components/Container.tsx";
import ContainerHeader from "../../components/ContainerHeader.tsx";
import { Trans, useLingui } from "@lingui/react/macro";
import { useUserBookingQuery } from "../../api/bookingApi.ts";

const MoveBookingPage = () => {
  const { i18n } = useLingui();
  const { bookingId, userId } = useParams();
  const [searchParams] = useSearchParams();
  const counterRequestId = searchParams.get("counter") ?? undefined;
  const { data: booking } = useUserBookingQuery(bookingId);

  const backTo =
    booking?.teacherId === userId
      ? "/mystudio/bookings"
      : `/user/${userId}/bookings/${bookingId}`;

  return (
    <main className="flex w-full items-center justify-center px-4 pt-4">
      <Container className={"max-w-3xl min-w-1/2"}>
        <BackButton to={backTo} label={i18n._("Back")} />
        <ContainerHeader>
          {counterRequestId ? (
            <Trans>Suggest Different Times</Trans>
          ) : (
            <Trans>Move Booking</Trans>
          )}
        </ContainerHeader>
        <MoveBooking
          bookingId={bookingId || ""}
          counterRequestId={counterRequestId}
          successRedirectTo={backTo}
        />
      </Container>
    </main>
  );
};

export default MoveBookingPage;
